import universal from '../../universal';
import errors from './errors';

export default {
    //#region ERRORS
    "username taken": "Nom d'utilisateur déjà utilisé",
    //#endregion

    create: "créer",
    update: "modifier",
    delete: "supprimer",
    search: "Rechercher",
    load: "Charger",
    no_file_loaded: "Aucun fichier chargé",

    created: "Créé",
    insert: "Inséré",
    not: "Non",
    show_hide: "Afficher/Masquer",
    change: "Changer",
    visibility: "Visibilité",
    polygon: "Polygone",
    make_active: "Activer",
    make_deactivate: "Désactiver",
    enable: "Activer",
    disable: "Désactiver",
    choose: "Choisir",
    select: "Sélectionner",
    apply: "Appliquer",
    rows: "Lignes",
    rows_visibility: "Visibilité des Lignes",
    existent: "Existant",
    existents: "Existants",
    unexistents: "Inexistants",
    interventions_list: "Liste des Interventions",
    from: "de",
    to: "à",
    row: "Ligne",
    rows: "Lignes",
    elements: "Éléments",

    errors,
    universal,

    home: 'Accueil',
    test: 'Test',

    field_data_survey: 'Qualifications',
    field_data_monitor: 'Moniteur Qualifications',
    export: 'Exporter',
    import: 'Importer',
    imported: 'Importé',
    fixed_network: 'Réseau Fixe',
    import_export: 'Import/Export',
    infoworks_export: 'Exportation Infoworks',
    dat_export: 'Exportation Dat',

    network_analysis: 'Analyse Réseau',
    lab_analytics: 'Analyses Laboratoire',
    performances: 'Performances',
    trash_by_statistics: 'Statistiques Trash-By',

    monitor: 'Moniteur',
    consumption_monitor: 'Moniteur Consommations',
    district_monitor: 'Moniteur District',
    pressure_monitor: 'Moniteur Pressions',
    realtime_monitor: 'Moniteur Temps Réel',

    operating_tools: 'Outils Opérationnels',
    user_registries: 'Registres Utilisateurs',
    route_analysis: 'Analyse Parcours',
    logical_paths: 'Parcours Logiques',

    workforcemanagement: 'Gestion Personnel',
    replacement_interventions: 'Interventions de Remplacement',
    planning: 'Planification',

    synchronization: 'Synchronisation',
    qualifications_sync: 'SYNC Qualifications',
    replacements_sync: 'SYNC Remplacements',
    walk_by_drive_by_sync: 'SYNC Walk-by/Drive-by',
    WFM_sync: 'SYNC WFM',
    work_force_management: 'Gestion de la Main-d\'œuvre',

    work_progress_status: 'État d\'Avancement des Travaux',

    "e-mail": "e-mail",
    wrong_email_password: "e-mail ou mot de passe incorrects",
    login: "Se connecter",
    username: "Nom d'utilisateur",
    Lastname: "Nom",
    Firstname: "Prénom",
    Role: "Rôle",
    password: "Mot de passe",
    log_in_into_your_account: "Connectez-vous à votre compte",
    forgot_password: "Mot de passe oublié ?",
    reset_password: "Réinitialiser le mot de passe",
    reset: "Réinitialiser",
    back_to_login: "Retour à la connexion",
    password_request_completed: 'Demande de réinitialisation du mot de passe effectuée avec succès.',
    check_your_inbox: 'Vérifiez votre boîte de réception.',
    didnt_receive_email: 'Vous n\'avez pas reçu l\'email ?',
    send_again: 'Envoyer à nouveau',
    repeat_password: "Répéter le mot de passe",
    password_reset_request_failed_or_expired: 'La demande de réinitialisation du mot de passe a échoué ou a expiré.',
    password_reset_successfully: 'Le mot de passe a été réinitialisé avec succès !',
    logout: "Se déconnecter",

    editor: "Modification/Visualisation",
    viewer: "Visualisation Seule",
    disabled: "Désactivé",

    active: "Actif",
    replaced: "Remplacé",
    delivered: "Livré",
    fixed: "Réparé",
    on_fixing: "En Réparation",
    on_returning: "En Retour",
    on_delivering: "En Livraison",
    broken: "En Panne",
    returned: "Retourné",

    ValidFrom: "Début Validité",
    ValidTo: "Expiration",
    Status: "État",
    OrderRef: "Référence Commande",
    DateDelivered: "Date Livraison",
    alarm: 'Alarme',
    alarms: 'Alarmes',
    alarmsDictionary: {
        no_alarm: 'AUCUNE ALARME',
        BF: 'FLUX INVERSE',
        PE: 'PERSISTANCE',
        BX: 'BATTERIE',
        FM: 'CAPTEUR',
        TP: 'SABOTAGE',
        EX: 'CONSOMMATION EXCESSIVE',
        EM: 'CONSOMMATION ÉLEVÉE',
        RS: 'REMISE À ZÉRO',
        DF: 'FLUX DIRECT',
        TK: 'RESTAURATION SABOTAGE',
        RT: 'RESET',
        CR: 'ERREUR FIRMWARE',
        PM: 'AIMANT PROGRAMMATION',
        MG: 'SABOTAGE MAGNÉTIQUE',
        MC: 'SABOTAGE MÉCANIQUE',
        RV: 'MONTÉ À L\'ENVERS',
        AD: 'AIR DÉTECTÉ',
        BP: 'TUYAU CASSÉ',
        DR: 'SEC',
        MT: 'MÉTROLOGIE',
        SS: 'SYSTÈME',
        WQ: 'QUALITÉ EAU',
        PF: 'ARRÊT',
        LT: 'TEMPÉRATURE BASSE',
        PX: 'PERSISTANCE EXCESSIVE',
        PP: 'PERSISTANCE PASSÉE',
        PI: 'FUITE INTERMITTENTE',
        122: 'DÉFAILLANT',
        242: 'EN RÉSILIATION',
        342: 'RÉSILIÉ',
        306: 'SUPPRIMÉ',
        132: 'ALARME INCONNUE',
        116: 'REMPLACÉ',
        206: 'SUPPRIMÉ',
        999: 'ALARME INCONNUE',
        ICSE: 'EN COURS DE CESSATION',
        CNFA: 'CESSÉ À FACTURER',
        CFAT: 'CESSÉ FACTURÉ',
        ICSO: 'EN COURS DE SUSPENSION',
        SOSP: 'SUSPENDU',
        1: 'ÉTAT SERVICE 1',
        2: 'ÉTAT SERVICE 2',
        3: 'ÉTAT SERVICE 3',
        ES: 'TUYAU VIDE'
    },

    utilities: 'Services',
    meter: 'Compteur',
    meters: 'Compteurs',
    smart_meter: 'Compteur Intelligent',
    non_smart: 'Non-Intelligent',
    towns: 'Communes',
    municipalities: 'Communes',
    valid_readings: 'Relevés Valides',
    readings: 'Relevés',
    active_users: 'Utilisateurs actifs',

    brand: 'Marque',
    brands: 'Marques',

    communication: 'Communication',
    communication_type: 'Type Communication',

    device_type: 'Type Appareil',

    successfully_added: 'Ajouté avec succès !',
    successfully_updated: 'Mis à jour avec succès !',
    successfully_removed: 'Supprimé avec succès !',
    successfully_created: 'Créé avec succès !',
    successfully_imported: 'Importé avec succès !',

    server_error: 'Erreur du Serveur.',

    pick_a_date: 'Sélectionner une date',
    date_format: 'jj/mm/aaaa',
    confirm: 'Confirmer',
    selected_days: 'Jours sélectionnés',

    all_towns: 'Toutes les communes',
    all_municipalities: 'Toutes les communes',

    failed_update_no_changes: `Mise à jour non effectuée.\r\nVous n'avez apporté aucune modification à l'enregistrement.`,

    last_30_days: '30 derniers jours',
    last_7_days: '7 derniers jours',

    language: 'Langue',
    back: 'Retour',
    cancel: 'Annuler',

    really_want_logout: 'Voulez-vous vraiment vous déconnecter ?',

    demo: 'Demo',

    error_loading_menu: 'Erreur lors du chargement du menu latéral',
    error_logout: 'Erreur lors de la fermeture de la session en cours',
    error_saving_language: 'Erreur lors de l\'enregistrement de la langue choisie',

    "Lavorazione Sospesa": "Traitement Suspendu",
    "Sostituito": "Remplacé",
    "Mancata Rimozione": "Suppression Manquée",
    "Mancata Sostituzione": "Remplacement Manqué",
    "Non Lavorato": "Non Traité",
    "Rimosso": "Supprimé",

    save: 'Sauvegarder',

    plan: 'Plan',

    Terminal: 'Terminal',

    installation: 'Installation',
    repair: 'Réparation',
    replacement: 'Remplacement',
    removal: 'Suppression',
    reading: 'Relevé',
    georeferencing: 'Géoréférencement',

    already_present: 'Déjà Présent',

    you_must_select_an_intervention_type: 'Vous devez d\'abord sélectionner un type d\'intervention',

    add_to_new_route: 'Ajouter au nouveau parcours',
    add_to_existing_route: 'Ajouter au parcours sélectionné',
    add_selected: 'Ajouter Sélectionnés',
    remove_selected: 'Supprimer Sélectionnés',

    empty_plan: 'Vider le Plan',

    unprocessed: 'Non Traité',
    attempted_processing: 'Traitement Tenté',
    suspended: 'Suspendu',
    processed: 'Traité',

    select_a_list: 'Sélectionner une liste',
    select_operator: 'Sélectionner un opérateur',

    identity_code: 'Code Identité',
    accountholder: 'Raison Sociale',
    email: 'E-mail',
    telephone: 'Téléphone',

    registry_details: 'Registres',
    intervention: 'Intervention',

    geo: 'Géo',
    geo_data: 'Données Géographiques',
    latitude: 'Latitude',
    longitude: 'Longitude',
    altitude: 'Altitude',

    ciu: 'CIU',
    codiceUtente: "CIU",
    idModulo: "Module",
    intestatario: "Titulaire",
    indirizzo: "Adresse",
    matricola: "Numéro de série",
    idTipoUtenza: "ID Commune",
    lat: "Latitude",
    lng: "Longitude",
    statoInstallazione: "Installé",
    rowNumber: "N. Ligne",
    plan_id: "ID Plan",

    supply_code: 'Code Fourniture',

    intervention_type: 'Type d\'Intervention',
    intervention_status: 'État de l\'Intervention',

    old_brand: 'Ancienne Marque',
    new_brand: 'Nouvelle Marque',
    old_serial: 'Ancien Numéro de série',
    new_serial: 'Nouveau Numéro de série',
    old_reading: 'Ancien Relevé',
    old_reading_date: 'Date Ancien Relevé',
    new_reading: 'Nouveau Relevé',
    digits_number: 'Nombre de Chiffres',
    seal_code: 'Code du Sceau',
    valve: 'Vanne',

    anomaly: "Anomalie",
    anomaly_notes: "Notes Anomalie",

    intervention_specifics: 'Spécificités Intervention',
    intervention_result: 'Résultat Intervention',
    result: 'Résultat',

    district: 'District',
    address: 'Adresse',
    municipality: 'Commune',

    old_location: 'Ancienne Position',
    new_location: 'Nouvelle Position',

    miscellaneous: 'Divers',

    causal: 'Causale',
    note: 'Note',
    notes: 'Notes',

    annotation: 'Annotation',
    annotations: 'Annotations',

    all_plans: 'Tous les Plans',
    edit_intervention: 'Modifier Intervention',

    exportation: 'Exportation',
    importation: 'Importation',

    preview: 'Aperçu',
    parameters: 'Paramètres',

    select_exportation: 'Sélectionner Exportation',
    start_date: 'Date de Début',
    end_date: 'Date de Fin',
    archived_at: 'Date Archivage',
    status: 'État',
    date: 'Date',

    witness: 'Nom et Prénom Témoin',

    separator: 'Séparateur',
    format: 'Format',

    trash_by_tools: 'Outils Trash-By',
    trash_by_stats: 'Statistiques Trash-By',
    walk_by_drive_by_tools: 'Outils Walk-By/Drive-By',
    assignment: 'Affectation',
    district_metering: 'Mesure District',
    geotool: 'Géooutil',
    intervention_management: 'Gestion Interventions',

    press_shift_space_to_switch_working_mode: "Pour changer de mode de travail, appuyez sur ",
    designer_mode: 'Mode Concepteur',
    viewer_mode: 'Mode Visualiseur',

    procedures: 'Procédures',

    add: 'Ajouter',
    remove: 'Supprimer',
    edit: 'Modifier',

    created_at: 'Date Création',
    updated_at: 'Date Modification',

    route_generator: 'Générateur de Parcours Logiques',
    house_number: 'Numéro',
    serial_number: 'Numéro de Série',
    serial: 'Numéro de série',
    identification_number: 'Numéro d\'identification',

    create_path: 'Créer Parcours',
    edit_path: 'Modifier Parcours',

    name: 'Nom',
    surname: 'Nom',
    firstname: 'Prénom',
    lastname: 'Nom',

    operator: 'Opérateur',
    anomaly: 'Anomalie',
    anomaly_notes: 'Notes Anomalie',
    type: 'Type',
    supply_type: 'Type de Fourniture',

    intervention_date: 'Date Intervention',
    intervention_start_date: 'Date Début Intervention',
    intervention_end_date: 'Date Fin Intervention',

    all_photos: 'Toutes les Photos',

    gallery: 'Galerie',
    logs: 'Journaux',

    you_have_to_select_a_route: 'Vous devez sélectionner un parcours !',

    ok: 'Ok',
    no: 'Non',
    yes: 'Oui',

    follow_center: 'Suivre le centre',
    generated_routes: 'Parcours Générés',

    photo: 'Photo',
    photos: 'Photos',

    management: 'Gestion',

    administrator: 'Administrateur',
    admin: 'Administrateur',

    delete: 'Supprimer',

    location: 'Position',
    group: 'Groupe',
    odi: 'ODI',
    id: 'ID',

    period: 'Période',

    module: 'Module',

    end_users: 'Services',

    create_route: 'Créer parcours',
    insert_interventions: 'Insertion interventions sur plan existant',
    by_changing_selection_lose_your_progress_proceed: 'En changeant la sélection, vous perdrez tous vos progrès.\nProcéder ?',

    delete_route: 'Supprimer parcours',
    reset_routes: 'Réinitialiser parcours',

    are_you_sure_wanna_proceed: `Confirmez-vous de procéder?`,
    are_you_sure_wanna_delete_route: 'Êtes-vous sûr de vouloir supprimer le parcours sélectionné ?',
    are_you_sure_wanna_reset_routes: 'Êtes-vous sûr de vouloir supprimer tous les parcours générés ?',
    are_you_sure_wanna_delete_this_photo: 'Êtes-vous sûr de vouloir supprimer cette photo ?',

    tips: 'Conseils',
    press_ctrl_and_click_to_draw_selection_area: 'Appuyez sur Ctrl et Cliquez pour tracer une zone de sélection.',
    double_click_to_reset_selection_area: 'Double-cliquez pour réinitialiser la zone de sélection.',

    notice_date: 'Date de notification',

    end_user: 'Service',

    transmission: 'Transmission',
    transmissions: 'Transmissions',

    environment: 'Environnement',
    newMeter: 'Nouveau Compteur',
    signatureUser: 'Signature Client',
    oldMeter: 'Ancien Compteur',

    category: 'Catégorie',
    select_a_category: 'Sélectionner une Catégorie',

    import_list: 'Importer Liste',

    lists: 'Listes',
    map: 'Carte',

    accepted_files: 'Fichiers acceptés',

    drag_and_drop_file_here: 'Glissez et déposez un fichier ici',

    kpi: 'KPI',

    stay_logged_in: 'Rester connecté',

    code: 'Code',
    device_not_registered: 'Appareil non enregistré',
    check_email_for_code: 'Vérifiez votre boîte e-mail et saisissez le code pour pouvoir accéder',

    you_can_try_login_again_in: `Vous pourrez tenter de vous reconnecter dans`,

    yesterday: 'Hier',
    realtime: 'Temps réel',

    red_meters: 'Compteurs lus',
    active_alarms: 'Alarmes actives',

    visualization: 'Visualisation',

    reset_selection: 'Réinitialiser sélection',

    tabular: 'Tabulaire',
    archive: 'Archive',

    store: 'Archiver',
    stored: 'Archivé',
    stored_s: 'Archivés',
    restore: 'Restaurer',

    are_you_sure_wanna_delete_plan: 'Êtes-vous sûr de vouloir supprimer le plan ?',
    deleting_plan_info: 'En procédant à la suppression, les affectations aux opérateurs seront supprimées et il ne sera plus possible de restaurer le plan.',
    are_you_sure_wanna_archive_plan: 'Êtes-vous sûr de vouloir archiver le plan ?',
    archiving_plan_info: 'En procédant à l\'archivage, les affectations aux opérateurs seront supprimées et il ne sera plus possible de visualiser les interventions.',
    are_you_sure_wanna_restore_plan: 'Êtes-vous sûr de vouloir restaurer le plan ?',

    proceeding_operation_misalignments_exports: 'En procédant à l\'opération, des désalignements dans les exportations pourraient survenir.',

    warning: 'Attention',
    plans: 'Plans',

    plan_assignment: 'Affectation Plans',

    available: 'Disponible',
    availables: 'Disponibles',

    stored_plans: 'Plans archivés',

    assign_or_remove_plan_before_change_operator: <>Affecter ou Supprimer les <span className='text-success'>plans</span> pour l'Opérateur actuel avant de pouvoir modifier la sélection.</>,

    assign_plans: 'Affecter plans',

    are_you_sure_wanna_delete_list: 'Êtes-vous sûr de vouloir supprimer la liste ?',
    assigned: 'Affecté',
    unassigned: 'Non Affecté',

    empty_selection: 'Vider sélection',
    create_new: 'Créer nouveau',
    add_move: 'Ajouter/Déplacer',
    interventions: 'Interventions',
    selected: 'Sélectionné',
    selected_s: 'Sélectionnés',
    move: 'Déplacer',

    list_name: 'Nom liste',
    plan_name: 'Nom Plan',

    diameter: 'Diamètre',
    diameter_mm: 'Diamètre (mm)',

    seal: 'Sceau',

    //Customizzazione InterventionManagementATENA
    provincia: 'Province',
    posizione_contatore: 'Position compteur',
    luogo_contatore: 'Lieu compteur'
};